import { isEmpty } from 'lodash';

import { ProviderState } from '../app/components/types';

const getProviderDisplayNames = (data: ProviderState | null) => {
  if (isEmpty(data) || !data) {
    return ['', ''];
  }
  const prefix = !data.prefix ? '' : data.prefix + '.';
  let l1 = [prefix, data.first_name, data.middle_name, data.last_name]
    .filter(x => x)
    .join(' ')
    .trim();
  // l1 = !data.title ? l1 : l1 + ', ' + data.title;

  const l2 = data.specialty_name && data.sub_specialty_name ? [data.specialty_name, data.sub_specialty_name].join(' ') : '';

  const l3 = data.city_name && data.state_abbreviation ? `${data.city_name}, ${data.state_abbreviation}` : '';

  return [l1, l2, l3];
};

export default getProviderDisplayNames;
